import React, { Component } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchPayment } from './actions';
import { getChild } from '../reducer';
import PaymentView from './View';
import BackButton from '../../common/components/BackButton';
import queryString from 'query-string';

class Details extends Component {
	constructor(props) {
		super(props);
		this.termDisplayName = this.termDisplayName.bind(this);
	}

	componentDidMount() {
		this.props.fetchPayment(Number(this.props.match.params.id), this.props.match.params.type);
	}

	termDisplayName(term) {
		return term ? term.name : '';
	}

	render() {
		const { payment, terms, grades, enableUserTimeZone, franchisorCurrency, updatePaymentOption, paymentOptionUpdateSuccess, paymentOptionUpdateFailure, paymentOptionUpdateFailureReason, t } = this.props;

		return <div>
			{payment && paymentOptionUpdateSuccess && <Alert bsStyle='success'>
				<div>{t(`FO_PaymentMethod_${payment.paymentMethod.name}_PaymentOptionUpdate_Success`)}</div>
			</Alert>}
			{payment && paymentOptionUpdateFailure && <Alert bsStyle='danger'>
				<div>{t(`FO_PaymentMethod_${payment.paymentMethod.name}_PaymentOptionUpdate_Failure`, { reason: paymentOptionUpdateFailureReason })}</div>
			</Alert>}
			{payment && <PaymentView payment={payment} terms={terms} grades={grades} enableUserTimeZone={enableUserTimeZone} franchisorCurrency={franchisorCurrency}
				termDisplayName={this.termDisplayName} />}
			<Row className='parent-dashboard-box'>
				<Col sm={12}>
					<BackButton />
				</Col>
			</Row>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const paymentId = ownProps.match.params.id;
	const queryParams = queryString.parse(ownProps.location.search);

	const { parent, entities: { payments, centers, terms, grades }, configuration: { franchisor } } = state;

	const payment = payments[paymentId];
	if (payment) {
		payment.parent = parent;
		payment.child = getChild(parent, payment.childId);
		payment.center = centers[payment.centerId];

		if (payment.lesson) {
			payment.lesson.center = centers[payment.lesson.centerId];
			payment.lesson.term = terms[payment.lesson.termId];
			payment.lesson.grade = grades[payment.lesson.gradeId];
		}
	}

	return {
		payment,
		terms,
		grades,
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone,
		franchisorCurrency: franchisor && franchisor.currency,
		paymentOptionUpdateSuccess: queryParams.cardUpdated && queryParams.cardUpdated === 'true',
		paymentOptionUpdateFailure: queryParams.cardUpdated && queryParams.cardUpdated === 'false',
		paymentOptionUpdateFailureReason: queryParams.reason
	};
};

export default connect(mapStateToProps, {
	fetchPayment
})(withTranslation()(Details));